import {
  IUseCreateTreatment,
  useCreateTreatment,
} from "../../common/treatment/treatment";

export const useCreateTreatmentCaller = (): IUseCreateTreatment => {
  const {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerRange,
    handleSubmitRange,
    unRegisterRange,
    errorsRange,
    appendRange,
    rangeFields,
    rangeRemove,
    loading,
  } = useCreateTreatment();

  return {
    onSubmit,
    formValue,
    setFormValue,
    registerGeneral,
    handleSubmitGeneral,
    errorsGeneral,
    registerRange,
    handleSubmitRange,
    unRegisterRange,
    errorsRange,
    appendRange,
    rangeFields,
    rangeRemove,
    loading,
  };
};
